import { Component, Injector } from '@angular/core';
import { BaseFormComponent } from '../base-form.component';
import { AmorphicService } from '../../../../services/amorphic/amorphic.service';
import { Customer } from '../../../../../../common/js/customer/Customer';
import type { Policy } from '../../../../../../common/js/customer/Policy';
import { CoverpathCustomer } from '../../../../../classes/coverpath_subclasses/CoverpathCustomer';

@Component({
  moduleId: module.id,
  selector: 'section-owner-email',
  templateUrl: './section-owner-email.component.html',
})
export class SectionOwnerEmailComponent extends BaseFormComponent {
  shouldLock: boolean = true;
  ownerEmail: string;
  customer: Customer;
  policy: Policy;
  isError: boolean;

  constructor(protected injector: Injector, private amorphicService: AmorphicService) {
    super(injector);
    this.customer = amorphicService.controller.customer;
    this.policy = this.customer.application.primaryPolicy;
  }

  async ngOnInit() {
    this.shouldLock = this.isAdvisor && (this.customer as CoverpathCustomer).hasRegistered;
    this.ownerEmail = this.customer.application.primaryPolicy.ownerPerson.email;
  }

  async saveOwnerEmail() {
    this.isError = await this.validateAndSet('customer.application.primaryPolicy.ownerPerson.email', this.ownerEmail);
  }

  handleBlur() {
    if (!this.errorMessage['customer.application.primaryPolicy.ownerPerson.email']) {
      this.checkEmptyAndValidate('customer.application.primaryPolicy.ownerPerson.email', this.ownerEmail);
    }
  }

  clearErrors(): void {
    this.errorMessage = {};
    this.isError = false;
  }

  updateFromModel() {}
}
